import React, { useRef } from 'react'
import GgGolfHubPopup from '../../gg_golf_hub/components/shared/gg_golf_hub_popup'
import { GGButton } from '../../shared/new_components/GGButton'
import PropTypes from 'prop-types'

const SMALL_SCREEN_BREAKPOINT = 992

const UploadCropImagePopup = ({
  isOpen,
  onClose,
  onConfirm,
  isConfirmDisabled,
  confirmText = window.I18n.t('views.golfhub.modal.done'),
  title,
  isUpload = true,
  imagePreviewSrc,
  imagePreviewComponent,
  imagePreviewHeader,
  imagePreviewDetails,
  handleImageUpload,
  photoFormats,
  photoRequirements,
  uploadLabel = window.I18n.t('views.golfhub.upload_crop_image.upload_photo'),
}) => {
  const inputRef = useRef(null)
  const handleClick = (e) => {
    e.preventDefault()
    inputRef.current?.click()
  }
  const uploadButtonTextKey = window.innerWidth <= SMALL_SCREEN_BREAKPOINT
    ? window.I18n.t('views.golfhub.upload_crop_image.upload_photo_short')
    : uploadLabel
  return (
    <GgGolfHubPopup
      isOpen={isOpen}
      onClose={() => onClose()}
      onConfirm={() => onConfirm()}
      isConfirmDisabled={isConfirmDisabled}
      confirmText={confirmText}
      title={title}>
      <div className='photo-upload'>
        {isUpload && <div className='photo-upload-content'>
          <div className='photo-upload-preview'>
            {imagePreviewSrc ? (
              <img
                src={imagePreviewSrc}
                alt={window.I18n.t('views.golfhub.photo_preview_alt')}
                className='photo-upload-image-uploaded'
              />
            ) : (
              <i className='fa-regular fa-image photo-upload-placeholder-icon' aria-hidden='true' />
            )}
          </div>
          <div className='photo-upload-action'>
            <GGButton
              label={uploadButtonTextKey}
              onClick={(e) => handleClick(e)}
            />
            <input
              className='photo-upload-input'
              ref={inputRef}
              type='file'
              onChange={(e) => handleImageUpload(e)}
              accept='image/jpeg, image/png, image/gif, image/bmp'
            />
          </div>
        </div>}
        <div className='photo-upload-hint'>
          <div>{photoFormats}</div>
          <div>{photoRequirements}</div>
        </div>
        <div className='error-message btsp_alert_notices hidden add-margin-bottom-10 add-padding-all-5' />
        {imagePreviewSrc &&
          <div className='image-preview add-margin-top-20'>
            <div className='image-preview-text'>
              <div className='resize-logo'>
                <i className='fa-regular fa-crop-simple' aria-hidden='true' />
              </div>
              <div className='add-margin-left-10'>
                <div className='bold'>{imagePreviewHeader}</div>
                <div>{imagePreviewDetails}</div>
              </div>
            </div>
            {imagePreviewComponent}
          </div>}
      </div>
    </GgGolfHubPopup>
  )
}
UploadCropImagePopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isConfirmDisabled: PropTypes.bool,
  confirmText: PropTypes.string,
  title: PropTypes.string.isRequired,
  isUpload: PropTypes.bool,
  imagePreviewSrc: PropTypes.string,
  imagePreviewComponent: PropTypes.node,
  imagePreviewHeader: PropTypes.string,
  imagePreviewDetails: PropTypes.string,
  handleImageUpload: PropTypes.func,
  photoFormats: PropTypes.string,
  photoRequirements: PropTypes.string,
  uploadLabel: PropTypes.string,
}

export default UploadCropImagePopup
